import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MobileNavbar.css';

const MobileNavbar = ({ 
    userAPIData, 
    isOpen, 
    onClose,
    notificacoes = [],
    loadingNotificacoes = false,
    notificacoesNaoVisualizadas = 0,
    marcarComoVisualizada,
    truncarTexto,
    formatarData,
    terapeutaLogada,
    handleLogout
}) => {
    const location = useLocation();

    // Função para verificar se o usuário tem acesso a um item do menu
    const hasAccess = (menuItem) => {
        if (!userAPIData) {
            return false;
        }

        const roleId = userAPIData.userRole?.id || userAPIData.userRoleId;

        // Verificação explícita e defensiva
        if (roleId === null || roleId === undefined) {
            return false;
        }

        // Se roleId = 6, mostrar APENAS o item agendamentos (calendário somente leitura)
        // Verificação estrita com === para evitar problemas de tipo
        if (Number(roleId) === 6) {
            return menuItem === 'agendamentos';
        }

        if (Number(roleId) === 4) {
            const allowedItems = [
                'dashboard',
                'agendamentos',
                'nosso-time',
                'pacientes',
                'responsaveis',
                'prestadores-servico'
            ];
            return allowedItems.includes(menuItem);
        }

        if (Number(roleId) === 5) {
            return menuItem === 'exportacoes';
        }

        return true;
    };

    // Fechar menu quando a rota mudar
    useEffect(() => {
        if (isOpen) {
            onClose();
        }
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    // Verificar se é role 6 para renderização condicional
    const isRole6 = userAPIData && (Number(userAPIData.userRoleId) === 6 || Number(userAPIData.userRole?.id) === 6);
    const roleId = userAPIData ? Number(userAPIData.userRole?.id || userAPIData.userRoleId) : null;
    const canAccessTriagem = [1, 2, 4].includes(roleId);

    return (
        <div className={`mobile-navbar ${isOpen ? 'open' : ''}`}>
            <div className="mobile-navbar-content">
                <ul className="mobile-nav-list">
                    {/* Para role 6, mostrar APENAS o menu de Agendamentos */}
                    {isRole6 ? (
                        <li className="mobile-nav-item">
                            <Link to={"/Calendario"} className="mobile-nav-link" onClick={onClose}>
                                <i className="fa-solid fa-calendar-days me-2"></i>
                                <span>Agendamentos</span>
                            </Link>
                        </li>
                    ) : (
                        <>
                            {hasAccess('dashboard') && (
                                <li className="mobile-nav-item">
                                    <Link to={"/"} className="mobile-nav-link" onClick={onClose}>
                                        <i className="fa-solid fa-house me-2"></i>
                                        <span>Dashboard</span>
                                    </Link>
                                </li>
                            )}

                            {hasAccess('agendamentos') && (
                                <li className="mobile-nav-item">
                                    <Link to={"/Calendario"} className="mobile-nav-link" onClick={onClose}>
                                        <i className="fa-solid fa-calendar-days me-2"></i>
                                        <span>Agendamentos</span>
                                    </Link>
                                </li>
                            )}
                        </>
                    )}

                    {!isRole6 && canAccessTriagem && hasAccess('pacientes') && (
                        <li className="mobile-nav-item">
                            <Link to={"/Triagens"} className="mobile-nav-link" onClick={onClose}>
                                <i className="fa-solid fa-clipboard-list me-2"></i>
                                <span>Triagem</span>
                            </Link>
                        </li>
                    )}

                    {!isRole6 && hasAccess('pacientes') && (
                        <li className="mobile-nav-item">
                            <Link to={"/Pacientes"} className="mobile-nav-link" onClick={onClose}>
                                <i className="fa-solid fa-children me-2"></i>
                                <span>Pacientes</span>
                            </Link>
                        </li>
                    )}
                    {!isRole6 && hasAccess('pacientes') && (
                        <li className="mobile-nav-item">
                            <Link to={"/PacientesBeta"} className="mobile-nav-link" onClick={onClose}>
                                <i className="fa-solid fa-list me-2"></i>
                                <span>Pacientes (beta)</span>
                            </Link>
                        </li>
                    )}

                    {!isRole6 && ((hasAccess('nosso-time') || hasAccess('pacientes') || hasAccess('responsaveis') || hasAccess('usuarios') || hasAccess('prestadores-servico'))) && (
                        <li className="mobile-nav-item">
                            <div className="mobile-nav-link mobile-nav-parent">
                                <i className="fa-solid fa-folder-open me-2"></i>
                                <span>Cadastros</span>
                            </div>
                            <ul className="mobile-nav-submenu">
                                {hasAccess('nosso-time') && (
                                    <li>
                                        <Link to={'/Terapeutas'} className="mobile-nav-sublink" onClick={onClose}>
                                            <i className="fa-solid fa-people-group me-2"></i>
                                            Nosso Time
                                        </Link>
                                    </li>
                                )}
                                {/* {hasAccess('responsaveis') && (
                                    <li>
                                        <Link to={"/Responsaveis"} className="mobile-nav-sublink" onClick={onClose}>
                                            <i className="fa-solid fa-person me-2"></i>
                                            Responsaveis
                                        </Link>
                                    </li>
                                )} */}
                                {hasAccess('prestadores-servico') && (
                                    <li>
                                        <Link to={"/PrestServicos"} className="mobile-nav-sublink" onClick={onClose}>
                                            <i className="fa-solid fa-screwdriver-wrench me-2"></i>
                                            Prestadores de Serviço
                                        </Link>
                                    </li>
                                )}
                                {userAPIData && hasAccess('usuarios') && (
                                    <li>
                                        <Link to={"/Usuarios"} className="mobile-nav-sublink" onClick={onClose}>
                                            <i className="fa-solid fa-user-gear me-2"></i>
                                            Usuários
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </li>
                    )}

                    {/* Menu Gestão - não mostrar para role 6 (somente leitura) */}
                    {userAPIData && Number(userAPIData.userRoleId) !== 6 && Number(userAPIData.userRole?.id) !== 6 && (hasAccess('exportacoes') || hasAccess('calendario-gerencial') || hasAccess('agendamentos')) && (
                        <li className="mobile-nav-item">
                            <div className="mobile-nav-link mobile-nav-parent">
                                <i className="fa-solid fa-chart-line me-2"></i>
                                <span>Gestão</span>
                            </div>
                            <ul className="mobile-nav-submenu">
                                {hasAccess('exportacoes') && (
                                    <li>
                                        <Link to={"/Exportacoes"} className="mobile-nav-sublink" onClick={onClose}>
                                            <i className="fa-solid fa-file-arrow-down me-2"></i>
                                            Exportações
                                        </Link>
                                    </li>
                                )}
                                {hasAccess('calendario-gerencial') && (
                                    <li>
                                        <Link to={"/Calendario/Gerenciamento"} className="mobile-nav-sublink" onClick={onClose}>
                                            <i className="fa-regular fa-calendar-plus me-2"></i>
                                            Calendário
                                        </Link>
                                    </li>
                                )}
                                {hasAccess('agendamentos') && (
                                    <li>
                                        <Link to={"/Calendario/Reposicoes"} className="mobile-nav-sublink" onClick={onClose}>
                                            <i className="fa-solid fa-calendar-check me-2"></i>
                                            Reposições
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </li>
                    )}

                    {!isRole6 && userAPIData && hasAccess('avisos') && (
                        <li className="mobile-nav-item">
                            <Link to={"/Avisos"} className="mobile-nav-link" onClick={onClose}>
                                <i className="fa-solid fa-triangle-exclamation me-2"></i>
                                <span>Avisos</span>
                            </Link>
                        </li>
                    )}
                </ul>

                {/* Notificações e Perfil */}
                <div className="mobile-nav-footer">
                    <hr style={{ borderColor: 'rgba(255, 255, 255, 0.2)', margin: '1rem 0' }} />
                    
                    {/* Notificações */}
                    <div className="mobile-nav-item">
                        <Link 
                            to={`/Avisos?userId=${userAPIData?.id}`} 
                            className="mobile-nav-link" 
                            onClick={onClose}
                        >
                            <i className="fa fa-bell me-2"></i>
                            <span>Notificações</span>
                            {notificacoesNaoVisualizadas > 0 && (
                                <span className="badge bg-danger ms-2" style={{ fontSize: '0.65rem' }}>
                                    {notificacoesNaoVisualizadas > 9 ? '9+' : notificacoesNaoVisualizadas}
                                </span>
                            )}
                        </Link>
                    </div>

                    {/* Perfil */}
                    {userAPIData && (
                        <div className="mobile-nav-item">
                            <Link 
                                to={`/Usuarios/Editar/${userAPIData.id}`} 
                                className="mobile-nav-link" 
                                onClick={onClose}
                            >
                                <i className="fa fa-user-circle me-2"></i>
                                <span>Perfil</span>
                            </Link>
                        </div>
                    )}

                    {/* Minha Escala */}
                    {terapeutaLogada !== null && (
                        <div className="mobile-nav-item">
                            <Link 
                                to={`/Terapeutas/PerfilTerapeuta/${terapeutaLogada}`}
                                state={{ abrirEscala: true }}
                                className="mobile-nav-link" 
                                onClick={onClose}
                            >
                                <i className="fa fa-calendar-alt me-2"></i>
                                <span>Minha Escala</span>
                            </Link>
                        </div>
                    )}

                    {/* Sair */}
                    <div className="mobile-nav-item">
                        <a 
                            className="mobile-nav-link" 
                            onClick={() => {
                                if (handleLogout) {
                                    handleLogout();
                                }
                                onClose();
                            }}
                            style={{ cursor: 'pointer', color: 'rgba(255, 255, 255, 0.8)' }}
                        >
                            <i className="fa fa-sign-out-alt me-2"></i>
                            <span>Sair</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileNavbar;

